module.exports = __webpack_public_path__ + "img/AccountantAccess_500x500.098740aa.png";